import { useMemo } from "react";

import { IAPIError, IJSONAPIErrorCodes } from "shared/types";

export const useAPIError = ({
  apiError,
  message,
  errorCode,
}: {
  apiError?: IAPIError | null;
  message: string;
  errorCode: IJSONAPIErrorCodes;
}) => {
  const error = useMemo(() => {
    if (!apiError) return false;

    const { errorCodes } = apiError;

    if (errorCodes.includes(errorCode)) {
      return message;
    }

    return !!apiError;
  }, [apiError, errorCode, message]);

  return { error };
};
